module.exports = __webpack_public_path__ + "static/media/whyus2.c054bd66.png";